"use client";

import { useEffect, useRef, useState } from "react";
import HotelSearchBar from "@/components/HotelSearch/HotelSearchBar";
import "react-day-picker/style.css";

const DIGITAL_OCEAN_SPACES_CDN =
  "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

// ✅ Update this to your real video path in Spaces
const HERO_VIDEO_SRC = `${DIGITAL_OCEAN_SPACES_CDN}/Site/videos/hero.mp4?v=1`;

// Optional poster (thumbnail) - use any existing image if you want
const HERO_VIDEO_POSTER = `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/slider/slider-01.webp?v=2`;

// export default function SliderHero() {
//   const [isMobile, setIsMobile] = useState(false);
//   const [videoError, setVideoError] = useState(false);
//   const videoRef = useRef<HTMLVideoElement | null>(null);

//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // Try to start video (some browsers may block play until user gesture)
//   useEffect(() => {
//     const v = videoRef.current;
//     if (!v) return;
//     const p = v.play();
//     if (p && typeof (p as any).catch === "function") {
//       (p as any).catch(() => {
//         // ignored (autoplay restrictions)
//       });
//     }
//   }, []);

export default function SliderHero() {
  const [videoError, setVideoError] = useState(false);
  const [slowConnection, setSlowConnection] = useState(true); // default true = show image first
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const nav = navigator as any;
    const conn = nav.connection || nav.mozConnection || nav.webkitConnection;
    if (conn) {
      const slow =
        conn.saveData || ["slow-2g", "2g"].includes(conn.effectiveType);
      setSlowConnection(slow);
    } else {
      setSlowConnection(false); // no API, assume good connection
    }
  }, []);

  useEffect(() => {
    const v = videoRef.current;
    if (!v || slowConnection) return;
    const p = v.play();
    if (p && typeof (p as any).catch === "function") {
      (p as any).catch(() => {});
    }
  }, [slowConnection]);

  return (
    <section className="relative w-full">
      <h2 className="sr-only">Hero</h2>
      {/* Video Hero */}
      {/* <div className="relative w-full aspect-[4/3] md:aspect-[16/7] overflow-hidden bg-gray-200">
        {!videoError ? (
          <video
            ref={videoRef}
            className="absolute inset-0 h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            poster={HERO_VIDEO_POSTER}
            onError={() => setVideoError(true)}
          >
            <source src={HERO_VIDEO_SRC} type="video/mp4" />
          </video>
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center">
            <div className="text-white text-center p-8">
              <div className="text-4xl mb-4">🏝️</div>
              <div className="text-xl font-semibold">Video unavailable</div>
              <div className="text-sm mt-2 opacity-75">
                Please try again later
              </div>
            </div>
          </div>
        )} */}
      <div
        className="relative w-full aspect-[4/3] md:aspect-auto md:h-screen overflow-hidden bg-gray-200 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_VIDEO_POSTER})` }}
      >
        {!videoError && !slowConnection ? (
          <video
            ref={videoRef}
            className="absolute inset-0 h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            poster={HERO_VIDEO_POSTER}
            onError={() => setVideoError(true)}
          >
            <source src={HERO_VIDEO_SRC} type="video/mp4" />
          </video>
        ) : (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={HERO_VIDEO_POSTER}
            alt="LilyLanka Sri Lanka Travel"
            fetchPriority="high"
            className="absolute inset-0 h-full w-full object-cover"
          />
        )}

        {/* Overlay gradient for readability */}
        <div className="absolute inset-x-0 bottom-0 h-32 md:h-40 bg-gradient-to-t from-black/40 md:from-black/50 to-transparent pointer-events-none" />
      </div>

      {/* MOBILE: Search bar below video */}
      <div className="md:hidden relative bg-white px-3 py-3 shadow-lg z-30">
        <HotelSearchBar variant="list" transparent={false} />
      </div>

      {/* DESKTOP: Search bar overlay */}
      <div className="hidden md:block absolute inset-x-0 bottom-20 lg:bottom-32 z-30 px-4">
        {" "}
        <div className="max-w-5xl mx-auto">
          <HotelSearchBar variant="list" />
        </div>
      </div>
    </section>
  );
}
